const nc_chart_options = ({
    data
}) => ({
    title: {
        text: "",
        align: "left"
    },
    rangeSelector: {
        selected: 1
    },
    chart: {
        // type: "line",
        panKey: "alt",
        panning: true,
        borderRadius: 8,
    },
    xAxis: {
        type: "datetime",
        ordinal: false,
        gridLineColor: '#D2D8E5',
        lineColor: '#D2D8E5',
        scrollbar: {
            enabled: false
        },
        labels: {
            style: {
                fontFamily: 'Nunito',
                color: '#8F8F8F',
                fontSize: '10px'
            }
        }
    },
    yAxis: {
        gridLineColor: '#D2D8E5',
        lineColor: '#D2D8E5',
        startOnTick: false,
        endOnTick: false,
        minorGridLineWidth: 1.5,
        minorTickInterval: "auto",
        minorTickLength: 0.5,
        minorTickWidth: 0.5,
        minorTickPosition: "outside",

        labels: {
            y: 4,
            style: {
                fontFamily: 'Nunito',
                color: '#8F8F8F',
                fontSize: '10px'
            }
        },

    },
    series: [{
        name: "Nasal Cannula",
        showInLegend: false,
        color: '#E92319',
        data,
        gapSize: 2
    }],
    labels: {
        overflow: "scroll"
    },
    navigator: {
        enabled: false
    },
    scrollbar: {
        enabled: false
    },
    plotOptions: {
        series: {
            pointPadding: 0,
            groupPadding: 0,
            gapSize: 0,
            name: "",
        },
        line: {
            marker: {
                enabled: false
            }
        }
    },
    exporting: {
        enabled: true
    }
});


export default nc_chart_options;